/** @jsxImportSource @emotion/react */
import { Card } from "primereact/card";
import { formatMonto } from "../../../shared";

const plural = (n, singular, pluralTexto) =>
  `${n} ${n === 1 ? singular : pluralTexto}`;

function Tarjeta({ titulo, icono, color, monto, simbolo, children }) {
  return (
    <Card css={{ flex: "1 1 14rem", minWidth: "14rem" }}>
      <div
        css={{
          display: "flex",
          alignItems: "center",
          gap: "0.5em",
          color: `var(--${color}-700)`,
          fontWeight: "bold"
        }}
      >
        <i className={`pi ${icono}`} />
        {titulo}
      </div>
      <div
        css={{
          fontSize: "1.75rem",
          fontWeight: "bold",
          margin: "0.4em 0"
        }}
      >
        {simbolo} {formatMonto(Math.round(monto))}
      </div>
      <div css={{ fontSize: "0.9em" }}>{children}</div>
    </Card>
  );
}

/** Las tarjetas de totales del período en el panel de indicadores de facturación. */
export default function TarjetasResumen({ totales, simbolo, mostrarConIva }) {
  const sufijoIva = mostrarConIva ? "" : " (sin IVA)";
  const { facturado, anuladas, cobrado } = totales;

  return (
    <div css={{ display: "flex", flexWrap: "wrap", gap: "1em", marginBottom: "1em" }}>
      <Tarjeta
        titulo={`Facturado${sufijoIva}`}
        icono="pi-file"
        color="blue"
        monto={facturado.monto}
        simbolo={simbolo}
      >
        {plural(facturado.cantidad, "factura", "facturas")}
        {anuladas > 0 && ` · ${plural(anuladas, "anulada", "anuladas")}`}
      </Tarjeta>

      <Tarjeta
        titulo={`Cobrado${sufijoIva}`}
        icono="pi-check-circle"
        color="green"
        monto={cobrado.monto}
        simbolo={simbolo}
      >
        {plural(cobrado.cantidad, "factura", "facturas")}
      </Tarjeta>
    </div>
  );
}
